export default class DeviceAddController {
    /**
     * To hide unresolved var in template
     * @typedef {object} wizardForm
     */

    static get $inject() {
        return [
            '$state', '$stateParams', 'panel',
            'DeviceService',
            'WizardHandler',
            '$timeout',
            '$interval',
            '$uibModal',
            'gettext',
            'LanguageService'
        ];
    }

    DECT_PAIR_TIMEOUT = 90;

    is_first_device = true;
    device_id = '';
    device_type = 0;
    device_subtype = 0;
    connect_type = 0;
    pairing_step = 0;
    pairing_time_left = 0;
    is_paired = false;
    pairing_check_promise = null;
    alert = null;

    constructor($state, $stateParams, panel,
                DeviceService, WizardHandler, $timeout,
                $interval, $uibModal, gettext, LanguageService) {


        // ------ text init -------------

        this.sizesText = [gettext('small'), gettext('medium'), gettext('large'), gettext('xlarge'),
                          gettext('Short'), gettext('short'), gettext('Long'), gettext('long')
                        , gettext('video'), gettext('picture')]

        this.roomSizes = {
            'small' : gettext('Up to 10'),
            'medium': '10-20',
            'large' : '20-50',
            'xlarge': gettext('Over 50'),
        };

        this.petSizes = {
            'small': gettext('Up to 8kg'),
            'medium':gettext('8-15kg'   ),
            'large': gettext('15-25kg'  ),
            'xlarge':gettext('Over 25kg'),
        };

        this.furSizes = {
            'short': 'Short',
            'long':  'Long',
        };

        this.cameraModes = {
            'video': gettext('Record video'),
            'picture': gettext('Take pictures'),
        };

        // -----------------------------

        this.panel = panel;
        this.panelId = panel.control_panel.id;
        this.$state = $state;
        this.service = DeviceService;
        this.wizard = WizardHandler;
        this.$timeout = $timeout;
        this.$interval = $interval;
        this.$uibModal = $uibModal;
        this.LanguageService = LanguageService;

        // Special binding for twisted components using directive function binding in a wrong way
        this.startDectPairing = this._startDectPairing.bind(this);
        this.parseDeviceId = this._parseDeviceId.bind(this);
        this.addDevice = this._addDevice.bind(this);
        this.checkPaired = this._checkPaired.bind(this);
    }

    // --- VM Helpers -----------------

    /**
     * Get device info from code and check for DECT pairing status if device is DECT
     * @returns {boolean|Promise}
     * @private
     */
    _parseDeviceId() {
        this.working = true;
        [this.version, this.connect_type, this.device_type, this.device_subtype, this.device_id] = this.item.code.split('-');
        this.device_version = this.device_id.substr(0, 3);
        this.device_id = this.device_id.substr(3).toLowerCase();
        // Reset the device data:
        this.item = {
            code: this.item.code
        };
        let promise = this.service.checkDeviceUnknown(this.panelId, this.connect_type, this.device_id);
        this.device_type = this.service.getDeviceTypeObject(parseInt(this.device_type, 16));
        this.device_subtype = parseInt(this.device_subtype);
        this.setDefaults();
        if (this.connect_type == this.service.CONPROTO_DECT) {
            promise.then(unknown => {
                if (!unknown) {
                    return false;
                }
                // Ignore result of checkPaired at this point
                return this._checkPaired().then(() => true);
            });
        }
        return promise.then(res => {
            this.existing_device = !res;
            return res;
        })
            .finally(() => this.working = false);
    }

    _checkPaired() {
        if (this.pairing_wait) {
            return false;
        }
        return this.pairing_check_promise = this.service.checkDectPaired(this.panelId, this.device_id)
            .then(isPaired => {
                this.is_paired = isPaired;
                this.pairing_check_promise = null;
                return isPaired;
            });
    }

    /**
     * Check if this device needs DECT pairing. Returns boolean as string to be consumed by a stupid wizard directive
     * @returns {string}
     */
    notNeedPairing() {
        return this.connect_type != this.service.CONPROTO_DECT || (this.is_paired && !this.pairing_success) ? 'true' : 'false';
    }

    setDefaults() {
        if (this.device_type.is_zone) {
            this.item = _.extend(this.item, {stayMode: "0"});
        }
        switch (this.device_type.name) {
            case 'SDEVTYPE_PIR':
            case 'SDEVTYPE_CAM':
                this.item = _.extend(this.item, {
                    roomSize: 'medium',
                    hasPet: "0",
                    petSize: 'medium',
                    cameraMode: 'picture',
                })
        }
    }

    /**
     * Check device type to show specific wizard config pages
     * Returns boolean as string to be consumed by a stupid wizard directive
     * @param type Device type
     * @param cond Additional condition, optional.
     * @returns {string}
     */
    checkDeviceType(type, cond = true) {
        if (!_.isArray(type)) {
            type = [type];
        }
        return cond && this.device_type && ~type.map(t => (t || '').toUpperCase() === (this.device_type.name || '').toUpperCase()).indexOf(true) ? 'false' : 'true';
    }

    _addDevice() {
        this.alert = null;
        this.working = true;
        return this.service.createDevice(this.panelId, this.item).then(() => true)
            .catch(err => {
                this.alert = err.data && err.data.message || err.statusText;
            })
            .finally(() => {
                this.working = false;
                this.is_first_device = false;
            });
    }

    //noinspection JSUnusedGlobalSymbols
    /**
     * Wizard startover upon finish
     */
    finishedWizard() {
        this.wizard.wizard().reset();
        // Allow wizard to reset itself properly and then reset the data
        this.$timeout(() => {
            this.item = {};
            this.device_type = null;
        });
    }

    done() {
        this.$state.go('main.panel.new_device_status', {id: this.panel.id});
    }


    _waitForPairing() {
        return this.service.getDectPairingStatus(this.panelId, this.pairing_step + 1)
            .then(data => {
                if (this.pair_wait_poll) {
                    this.$interval.cancel(this.pair_wait_poll);
                    this.pairing_time_left = 0;
                    this.pair_wait_poll = null;
                }
                this.pairing_step = data.state;
                if (this.pairing_step < 3)
                    return this._waitForPairing();
                this.pairing_wait = false;
                return true;
            })
    }

    _startDectPairing() {
        this.pairing_error = false;
        this.pairing_wait = true;
        this.pairing_success = false;
        this.pairing_step = 0;
        this.pairing_time_left = this.DECT_PAIR_TIMEOUT;
        if (this.pair_wait_poll) {
            this.$interval.cancel(this.pair_wait_poll);
        }

        this.service.startDectPairing(this.panelId)
            .then(data => {
                if (data.status != "learning") {
                    throw new Error("Cannot enter pairing mode");
                }
                this.pairing_time_left = this.DECT_PAIR_TIMEOUT;
                this.pair_wait_poll = this.$interval(() => --this.pairing_time_left, 1000, this.DECT_PAIR_TIMEOUT);
                this.pairing_step = 0;
                return true;
            })
            .then(this._waitForPairing.bind(this))
            .then(() => {
                this.pairing_success = true;
                return true;
            })
            .then(this.checkPaired)
            .catch(() => {
                this.pairing_error = true;
                this.pairing_wait = false;
            })
            .finally(() => {
                this.pairing_step = 0;
            });
        return true;
    }

    getProgress() {
        return Math.floor(this.pairing_step / 3 * 100) + '%';
    }

    getPairingTime() {
        return Math.floor(this.pairing_time_left / this.DECT_PAIR_TIMEOUT * 100) + '%';
    }

    getTranslatableText(text) {
        return this.LanguageService.getTranslatableText(text);
    }
}


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/device_add/controller.js
 **/